/**
 * Query key factory for members queries
 * Follows TanStack Query best practices for hierarchical keys
 */
export const membersKeys = {
    all: ["members"] as const,
    detail: (uid: string) => [...membersKeys.details(), uid] as const,
    details: () => [...membersKeys.all, "detail"] as const,
    list: (filters: { search?: string; sort?: string }) => [...membersKeys.lists(), filters] as const,
    lists: () => [...membersKeys.all, "list"] as const,
};
